import { defineSettingsScreen } from '@heidi/runtime/shell';

/**
 * Declares the Document Inbox settings screen through the shell.
 */
export const inboxSettingsScreen = defineSettingsScreen({
  id: 'inbox',
  section: 'integrations',
  order: 3,
  load: () =>
    import('../document-inbox/ui/settings/InboxSettings').then((module) => ({
      default: module.InboxSettings,
    })),
  builds: 'all',
});
